import NoContentComponent from "@/app/components/ui/EmptyStates/NoContent";
import React from "react";
import { IOtherInformationTabProps } from "../../interface";

const OtherInformationTab: React.FC<IOtherInformationTabProps> = (_props) => {
  return <NoContentComponent />;
};

export default OtherInformationTab;
